import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";

export const CreateCaseFileAttachmentService=async(data)=>{
    try {
        const result = await post(`api/case_attachment/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCaseFileAttachmentService=async(data,id)=>{
    try {
        const result = await post(`api/case_attachment/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseFileAttachmentService=async(id)=>{
    try {
        const result = await get(`api/case_attachment/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}



export const DeleteCaseFileAttachmentService=async(id)=>{
    try {
        const result = await deleteRequest(`api/case_attachment/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

